var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Alive31'),_c('Alive32'),_c('Alive33'),_c('Alive34'),_c('Alive35'),_c('Alive36'),_c('Alive37'),_c('Alive38'),_c('Alive39')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }